import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {StripePaymentElementComponent, StripeService} from 'ngx-stripe';
import {
  Appearance,
  PaymentIntent,
  StripeElementsOptions,
  StripePaymentElementChangeEvent,
  StripePaymentElementOptions
} from '@stripe/stripe-js';
import {Store} from '@ngxs/store';
import {SettingsState} from '../../../state/settings.state';

@Component({
  standalone: false,
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./stripe.component.scss']
})
export class StripeComponent implements OnInit {

  @Input('paymentIntent') paymentIntent: PaymentIntent;
  paying: boolean;
  @Output('change') onChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(StripePaymentElementComponent)
  paymentElement: StripePaymentElementComponent;
  paymentOptions: StripePaymentElementOptions = {
    wallets: {
      applePay: 'auto',
      googlePay: 'auto',
    }
  };

  appearance: Appearance;

  savePaymentMethod = true;

  elementsOptions: StripeElementsOptions = {
    locale: 'en-AU',
    loader: 'auto'
  };
  isLoading: boolean;
  isValid: boolean;
  constructor(private store: Store, private stripeService: StripeService) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    const darkMode = this.store.selectSnapshot(SettingsState.darkMode);
    this.appearance = {
      theme: darkMode ? 'night' : 'stripe',
      labels: 'floating'
    };
  }

  pay(): void {
    this.paying = true;
    this.onChange.emit({loading: true});
    this.stripeService.confirmPayment({
      elements: this.paymentElement.elements,
      confirmParams: {
        payment_method_data: {}
      },
      redirect: 'if_required'
    }).subscribe(result => {
      this.paying = false;
      this.onChange.emit({
        ...result,
        savePaymentMethod: this.savePaymentMethod,
        loading: false,
      });
    });
  }

  reset(): void {
  }

  inputChange($event: StripePaymentElementChangeEvent): void {
    this.isValid = $event.complete;
  }
}
